import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

export const useLoyaltySettings = () => {
  const APIURL = "/loyalty/settings";
  const { data, error, isLoading } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
};

export const saveLoyaltySettings = async (settings) => {
  return await ApiClient.post("/loyalty/settings", settings);
};

export const getCustomerLoyalty = async (phone) => {
  const res = await ApiClient.get(`/loyalty/customer/${phone}`);
  return res.data;
};
